function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.4 7.85v4.3h9.2v-4.3A4.6 4.6 0 0 0 11 2.96a4.6 4.6 0 0 0-4.6 4.9zm-3.13 0A7.86 7.86 0 0 1 11.15 0c4.35 0 7.58 3.52 7.58 7.85v4.3h1.73c.54 0 .73.05.93.16.2.1.35.26.45.45.1.2.16.4.16.93v12.77c0 .54-.06.73-.16.93a1.09 1.09 0 0 1-.45.45c-.2.1-.4.16-.93.16H1.54C1 28 .8 27.94.6 27.84a1.09 1.09 0 0 1-.45-.45c-.1-.2-.16-.4-.16-.93V13.7c0-.54.06-.73.16-.93a1.09 1.09 0 0 1 .45-.45c.2-.1.4-.16.93-.16h1.73v-4.3z",
  fill: "#7F7F7F"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 28
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/bling_waitlist.479cd502.svg";
export { SvgComponent as ReactComponent };